import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CurrencyFormat from 'react-currency-format';
import moment from 'moment';

export default class DriverExpenseAccountAuditTrailBreakdown extends React.Component {
  constructor(props) {
    super(props);


    var that = this;
    var expenseAccountId  = $('#driver-expense-account-audit-trail-breakdown-modal').data('expense-account-id');

    this.state = {
      text: props.initialValue || 'placeholder',
      data: props.data || null,
      expense_account_id: props.expense_account_id || null,
      isLoading: true,
      loadFullTrailHistoryBtn: true,
    };
    
     Echo.channel('driver-expense-account-'+expenseAccountId)
    .listen('DriverExpenseAccountChanged', (e) => {
        that.getExpenseAccountAuditTrailBreakdown(expenseAccountId);
    });
    this.loadFullTrailHistory = this.loadFullTrailHistory.bind(this);
    this.getExpenseAccountAuditTrailBreakdown(expenseAccountId);
  }


  getExpenseAccountAuditTrailBreakdown(expenseAccountId) {
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/expense-accounts/'+expenseAccountId+'/audit-trail',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(driverExpenseAccountAuditTrailJson) {
      that.setState({
        data: driverExpenseAccountAuditTrailJson,
        isLoading: false,
        });
    });
  }

  loadFullTrailHistory() {
    return fetch('/api/v1/portal/drivers/expense-accounts/'+this.state.expense_account_id+'/audit-trail?full=true&api_token='+window.api_token,
      {
        method: 'GET',
        cache: 'no-cache'
      })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      this.setState({
        data: data,
        isLoading: false,
        loadFullTrailHistoryBtn: false,
        });
    }.bind(this));
  }

  render() {
    
    var DriverExpenseAccountAuditTrailBreakdownItems = [];
    const {data, expense_account_id, isLoading, loadFullTrailHistoryBtn} = this.state; 
    if (data && data.length > 0) {
      data.forEach(function(i) {
        DriverExpenseAccountAuditTrailBreakdownItems.push(
          <DriverExpenseAccountAuditTrailBreakdownItem key={expense_account_id+'-'+i.id} data={i} />
        );
      }.bind(this));
    }

    return(
      <div className="driver-expense-account-audit-trail-breakdown-container">
        {(loadFullTrailHistoryBtn) ?
        <div className="row">
          <div className="col-md-12 mt-2">
            <div className="alert alert-info " role="alert">
             <i className='fa fa-info-circle'></i> Showing last 3 months of history. Click "View Full Trail History" button to load all history.
            </div>
          </div>
        </div>:''}
      {
        (isLoading) ?
        (<div className="loading-box"><span className="add-loading-text"><i className="fa fa-spinner fa-pulse"></i></span></div>) :
        <div>
        <div className="row font-weight-bold">
          <div className="col-md-2 text-center">
            Time
          </div>

          <div className="col-md-3 text-left">
            Reference
          </div>

          <div className="col-md-2">
            Type
          </div>

          <div className="col-md-1 text-center">
            From
          </div>

          <div className="col-md-1 text-center">
            Balance
          </div>

          <div className="col-md-2">
            Actioned By
          </div>

          <div className="col-md-1">
            Associated Job<br />(if applicable)
          </div>
        </div>
        {DriverExpenseAccountAuditTrailBreakdownItems}
        {(loadFullTrailHistoryBtn) ?
        <div className="row">
          <div className="colmd-12">
            <button type="button" className="btn btn-block btn-primary" onClick={this.loadFullTrailHistory}>
              View Full Trail History
            </button>
          </div>
        </div>:''}
        </div>
      }
      </div>
    )
  }
}

class DriverExpenseAccountAuditTrailBreakdownItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      text: props.initialValue || 'placeholder',
      data: props.data || null,
    };
  }


  render() {
    var type = '?',
        from = '',
        to = '',
        job = '',
        Ref = '',
        limitColourise = '',
        momentFormatString = 'dddd Do MMMM YYYY @ h:mm:ssa';

    if (this.state.data.add_funds === 1) {
      type = 'Funds Added';
      from = this.state.data.expense_account_previous_total_value_in_pence;
      to = this.state.data.expense_account_current_total_value_in_pence;
    }

    if (this.state.data.remove_funds === 1) {
      type = "Funds Removed";
      from = this.state.data.expense_account_previous_total_value_in_pence;
      to = this.state.data.expense_account_current_total_value_in_pence;
    }

    if (this.state.data.manual_override_for_limit === 1) {
      type = <span>Manual Override for <span className='colourise-limit'>LIMIT</span></span>;
      from = this.state.data.expense_account_previous_limit_in_pence;
      to = this.state.data.expense_account_current_limit_in_pence;
      limitColourise = 'colourise-limit';
    }

    if (this.state.data.manual_override_for_total === 1) {
      type = <span>Manual Override for <strong>TOTAL</strong></span>;
      from = this.state.data.expense_account_previous_total_value_in_pence;
      to = this.state.data.expense_account_current_total_value_in_pence;
    }

    if (this.state.data.approve_expense === 1) {
      type = "Expense Approved";
      from = this.state.data.expense_account_previous_total_value_in_pence;
      to = this.state.data.expense_account_current_total_value_in_pence;
    }

    if (this.state.data.not_approve_expense === 1) {
      type = "Expense Not Approved";
      from = this.state.data.expense_account_previous_total_value_in_pence;
      to = this.state.data.expense_account_current_total_value_in_pence;
    }

    if (this.state.data.job_id !== null) {
      job = <span>Job #{this.state.data.job_id} <a href={"/jobs/view/"+this.state.data.job_id}><button className="btn btn-dark btn-sm">view job details</button></a></span>;
    }
    
    if (this.state.data.job !== null && this.state.data.job.vehicle !== null) {
        RegExp.escape = function(s) {
            return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        };
        if(this.state.data.job.vehicle.registration_number){
            var globalRegex = new RegExp(RegExp.escape(this.state.data.job.vehicle.registration_number), "i")
            if(!globalRegex.test(this.state.data.reference)){
                Ref = this.state.data.job.vehicle.registration_number;
            }
        }
    }

    return (
      <div className="row">
        <div className="col-md-2 display-block text-right">

          {moment(this.state.data.created_at).format(momentFormatString)}
        </div>
        <div className="col-md-3 text-left">
         {this.state.data.reference} {Ref}
         </div>
         <div className="col-md-2">
          {type}
         </div>
         <div className={"col-md-1 text-right "+limitColourise}>
             &pound;{(from/100).toFixed(2)}
         </div>
         <div className={"col-md-1 text-right "+limitColourise}>
           &pound;{(to/100).toFixed(2)}
         </div>
         <div className="col-md-2">
          <a href={"/portal-admin/users/view/"+this.state.data.user.id}>
            {this.state.data.user.first_name} {this.state.data.user.last_name}
          </a>
         &nbsp;from&nbsp;
         <strong>{this.state.data.user.company.short_name}</strong>
         </div>
         <div className="col-md-1">
          {job}
        </div>
      </div>
    );
  }
}
